import React from 'react';

import { Grid, useMediaQuery, useTheme } from '@mui/material';

import { CompanyAnalysisForm, CompanyAnalysisResponse } from '../types';
import FieldCard from './FieldCard';
import GlobalCard from './GlobalCard';

interface CategoryCardProps {
  category: CompanyAnalysisForm;
  icon: React.ReactNode;
  analysisReport: CompanyAnalysisResponse;
}

const CategoryCard: React.FC<CategoryCardProps> = ({ category, icon, analysisReport }) => {
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down('md'));

  const { name, fields } = category;

  const { users } = analysisReport;

  const fieldsWithResponses = fields.filter(field => field.responses && field.responses.length > 0);

  if (fieldsWithResponses.length === 0) {
    return null;
  }

  return (
    <GlobalCard icon={icon} title={name}>
      <Grid container spacing={2}>
        {fieldsWithResponses.map((field, index) => {
          const isLastItem = index === fieldsWithResponses.length - 1;
          const isOddTotal = fieldsWithResponses.length % 2 !== 0;

          // No desktop: se for ímpar e for o último item, ocupa toda a linha
          // No mobile: sempre uma coluna
          const gridSize = isMobile ? 12 : isOddTotal && isLastItem ? 12 : 6;

          return (
            <Grid item xs={12} md={gridSize} key={field.uuid}>
              <FieldCard field={field} users={users} />
            </Grid>
          );
        })}
      </Grid>
    </GlobalCard>
  );
};

export default CategoryCard;
